/*=========================================================================================
  File Name: module-supplier-mutations.js
  Description: Supplier Module Mutations
  ----------------------------------------------------------------------------------------
  Project: MISA InvoiceBots
  Author: MISA JSC
  Author URL: http://www.misa.com.vn
==========================================================================================*/
/**
 * state mặc định của module
 */
import defaultState from './module-supplier-state';

export default {
	/**
	 * Reset lại trạng thái của state
	 * @param {State} state
	 */
	resetState(state) {
		Object.assign(state, defaultState);
	},

	updateSuppliersLoaded(state, data) {
		state.SuppliersLoaded = data;
	},

	updateSuppliers(state, res) {
		state.Suppliers.removeAll();
		let result = res.Data;
		state.Suppliers.append(result.Data);
		if (res.isGetTotal) {
			// API có lấy ds hóa đơn có lấy thông tin tổng hóa đơn
			state.Total = result.Total;
		} else if (result.Total) {
			state.Total = result.Total ? result.Total : state.Total;
		}
	},

	updateSuppliersCombobox(state, res) {
		state.SuppliersCombobox.append(res.Data.Data);
	},

	deleteSuppliersCombobox(state, res) {
		state.SuppliersCombobox.removeAll();
	},

	updateSupplier(state, res) {
		state.Supplier = res;
	},

	deleteAndUpdateSupplierCombobox(state, res) {
		// Xóa nhà cung cấp khỏi danh sách
		state.SuppliersCombobox.removeAll();
		// Cập nhật lại danh sách nhà cung cấp
		if (res && res.length > 0) {
			state.SuppliersCombobox = res;
		} else {
			state.SuppliersCombobox = [];
		}
	},

	setSuppliersCombobox(state, data) {
		state.SuppliersCombobox.unshift(data);
	},

	updateSupplierRiskInfo(state, data) {
		state.SupplierRisks = [...data];
	},

	updateLoadingTotalRecords(state, res) {
		state.IsLoadingTotalRecords = res;
	},

	updateTotalPage(state, res) {
		state.Total = res || 0;
	}
};
